import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

export { formatCurrency } from "./format-currency";

export function anonymizePhoneNumber(phoneNumber: string) {
  const lastTwoDigits = phoneNumber.slice(-2);
  return `${formatPhoneNumber(phoneNumber)
    .slice(0, -2)
    .replace(/\d/g, "*")}${lastTwoDigits}`;
}

// FIXME causes compile errors if not behind client boundary
export function isUSPhone(value: string) {
  return parsePhoneNumber(value)?.country === "US";
}

// FIXME causes compile errors if not behind client boundary
export function formatPhoneNumber(value: string): string {
  const number = parsePhoneNumber(value);
  return !number
    ? ""
    : number.country === "US"
      ? number.formatNational()
      : number.formatInternational();
}

export function normalizePhoneInput(value: string | undefined): string {
  if (!value) {
    return "";
  }

  const stripped = value.replace(/\D/g, "");
  // if no plus code specified and valid us phone, assume it's american
  const withPlusCode =
    stripped.length === 10 && value[0] !== "+"
      ? `+1${stripped}`
      : `+${stripped}`;

  // this lets test phone numbers like 55599999464 pass without triggering the isValidPhoneNumber check since its a test phone number
  if (stripped.startsWith("555")) {
    return withPlusCode;
  }
  return isValidPhoneNumber(withPlusCode) ? withPlusCode : value;
}
